import prakerjaDateOffsetConfig from '@/api/prakerjaDateOffsetConfig'

export default {
  namespaced: true,
  state: {
    onlinePurchaseDateOffset: {
      isActive: true,
      start: null,
      end: 259200000 // in milliseconds, equal to 3 days
    },
    offlinePurchaseDateOffset: {
      isActive: true,
      start: null,
      end: 259200000 // in milliseconds, equal to 3 days
    },
    onlineRedemptionDateOffset: {
      isActive: true,
      start: 3600000, // in milliseconds, equal to 1 hour
      end: 3600000, // in milliseconds, equal to 1 hour
      tolerance: {
        isActive: true,
        start: null,
        end: 300000 // in milliseconds, equal to 5 minutes
      }
    },
    offlineRedemptionDateOffset: {
      isActive: true,
      start: 3600000, // in milliseconds, equal to 1 hour
      end: 7200000, // in milliseconds, equal to 2 hours
      tolerance: {
        isActive: true,
        start: null,
        end: 300000 // in milliseconds, equal to 5 minutes
      }
    },
    splRedemptionDateOffset: {
      isActive: true,
      start: null,
      end: 1296000000, // in milliseconds, equal to 15 days
      tolerance: {
        isActive: true,
        start: null,
        end: 86400000 // in milliseconds, equal to 24 hours
      }
    }
  },
  mutations: {
    SET_ONLINE_PURCHASE_DATE_OFFSET (state, payload) {
      state.onlinePurchaseDateOffset = payload
    },
    SET_OFFLINE_PURCHASE_DATE_OFFSET (state, payload) {
      state.offlinePurchaseDateOffset = payload
    },
    SET_ONLINE_REDEMPTION_DATE_OFFSET (state, payload) {
      state.onlineRedemptionDateOffset = payload
    },
    SET_OFFLINE_REDEMPTION_DATE_OFFSET (state, payload) {
      state.offlineRedemptionDateOffset = payload
    },
    SET_SPL_REDEMPTION_DATE_OFFSET (state, payload) {
      state.splRedemptionDateOffset = payload
    }
  },
  actions: {
    async fetchPrakerjaDateOffsetConfig ({ commit }) {
      const config = await prakerjaDateOffsetConfig.getPrakerjaDateOffsetConfig()
      if (config.onlinePurchaseDateOffset) {
        commit('SET_ONLINE_PURCHASE_DATE_OFFSET', config.onlinePurchaseDateOffset)
      }
      if (config.offlinePurchaseDateOffset) {
        commit('SET_OFFLINE_PURCHASE_DATE_OFFSET', config.offlinePurchaseDateOffset)
      }
      if (config.onlineRedemptionDateOffset) {
        commit('SET_ONLINE_REDEMPTION_DATE_OFFSET', config.onlineRedemptionDateOffset)
      }
      if (config.offlineRedemptionDateOffset) {
        commit('SET_OFFLINE_REDEMPTION_DATE_OFFSET', config.offlineRedemptionDateOffset)
      }
      if (config.splRedemptionDateOffset) {
        commit('SET_SPL_REDEMPTION_DATE_OFFSET', config.splRedemptionDateOffset)
      }
    }
  }
}
